import * as React from "react";
import {CSSProperties} from "react";


import {StoreControl, StoreControlProps, StoreControlState} from "shared/controls/base/StoreControl";
import {ValidatorBase} from "shared/utilities/validator/ValidatorBase";
import {PropertyValidator} from "shared/utilities/validator/PropertyValidator";
import {ColorButton} from "shared/controls/SingleInputs/SlateEditor/Buttons/ColorButton";
import {StoreBase} from "shared/core/Store/StoreBase";



export class RNColor<S extends StoreBase> extends StoreControl<RNColorProps<S>, RNColorState> {
    static defaultProps: Partial<RNColorProps<any>> = {};

    constructor(props: RNColorProps<S>) {
        super(props);
        this.state={
            IsValid:true,
            ErrorMessage:''
        }
    }

    public render() {
        return (
            <div className={'rncontrol'} style={this.props.style}>
                <div>
                    {   this.props.Label!=''&&
                    <label style={{width: '100%', display: 'block'}}>{this.props.Label}</label>
                    }
                    <ColorButton ColorChanged={e=>{this.SetValue(e)}} Color={this.GetStringValue()}/>
                    {this.GetValidationSection()}
                </div>
            </div>
        )
    }

    GetValidators(): ValidatorBase[] {
        return [
            new PropertyValidator(this.props,"Required",()=>{return this.GetStringValue()!=''},"Required field")
        ];
    }

    private ToHex() {
        let color=this.GetStringValue();

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface RNColorProps<S extends StoreBase> extends StoreControlProps<S>{
    style?:CSSProperties;
    Label:string;
    onChange?:(value:string)=>void;
    disabled?:boolean;
    type?:string;
    placeholder?:string;
}

interface RNColorState extends StoreControlState{

}

//#endregion "My Region"